module.exports = __webpack_public_path__ + "img/pt_tb.994b5676.png";